<template>
	<div class="container">

		<!-- Loading加载 -->
		<div class="loading" v-if="isDetail">
			<van-loading size="40px" type="spinner" color="#39CCCD" vertical>
				<div class="loading-text">
					<div>页面正在加载</div>
					<div>请稍候</div>
				</div>
			</van-loading>
		</div>

		<div v-show="!isDetail" class="content" @click="getWxInfo()">
			<img src="https://xxc.51xxc.com/app/static/baidu2_xcx.png" style="width: 100%;display: block;" />
		</div>
	</div>
</template>

<script>
var that;
import { Toast } from 'vant';
export default {
	name: 'userInfo_code',
	components: {},
	props: {},
	data() {
		return {
			isDetail: true,
			code: '',
			token: '',
		}
	},
	created() {
		that = this;
		that.token = this.$route.query.token;//3e560ba8d0f54e3596275ba12023eed6
		if (that.token) {
			localStorage.setItem('token', that.token)
		}
		//有code并且已经登录跳转老师二维码页
		const queryObj = this.getQueryObj()
		if (queryObj['code'] && that.token) {
			that.btnWXcode()
		}else{
			setTimeout(() => {
				that.isDetail = false;
			}, 500);
		}
	},
	methods: {
		//支付成功后获取微信昵称头像
		getWxInfo() {
			Toast.loading({
				message: '加载中',
				forbidClick: true,
				loadingType: 'circular'
			});
			console.log('获取vx授权code')
			window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd06acaafd7167053&redirect_uri=${encodeURIComponent(window.location.href + '#' + new Date().getTime())}&response_type=code&scope=snsapi_userinfo#wechat_redirect`)
		},

		to_link() {
			this.$router.push({
				path: '/smallprogram/success'
				// query: { id: this.id }
			})
		},

		btnWXcode() {
			const queryObj = this.getQueryObj()
			this.$http.get('/app/users/mergeMpInfo', {
				code: queryObj['code']
			}).then(res => {
				console.log(res)
				// this.getAgainCourse()
				setTimeout(() => {
					that.to_link()
				}, 500);
			})
		},

		//已购买训练营，如果训练营过期重新获取绑定最新训练营课程
		getAgainCourse() {
			this.$http.get('/app/users/updateTeacherByChannelId', {
				channelId: this.id
			}).then(res => {
				console.log('重新获取课程', res.data)
			})
		},

		getQueryObj() {
			var query = location.search
			var queryObj = {}
			var arr = query.slice(1, query.length).split('&')
			arr.forEach(function (val) {
				var arr1 = val.split('=')
				queryObj[arr1[0]] = arr1[1]
			})

			return queryObj
		},

	}
}
</script>

<style scoped lang="less">
.content {
	max-width: 100%;
	background-color: #fee3d0;
	position: absolute;
	width: 100%;
	height: 100%;

	.anniu {
		position: absolute;
		width: 100%;
		height: 100%;
		bottom: 0;
		left: 0;
		opacity: 0;
		z-index: 2;
	}
}


.finger {
	padding: 30px;
	background-color: #ff5725;
	line-height: 40px;
	font-weight: 500;
	font-size: 40px;
	width: 50%;
	border-radius: 100px;
	text-align: center;
	color: #ffffff;
	margin: 100px auto;
	animation: identifier .7s linear infinite;
}

@keyframes identifier {
	0% {
		transform: scale(.95);
	}

	50% {
		transform: scale(1.02);
	}

	100% {
		transform: scale(.95);
	}
}

.code_top2 {
	text-align: center;

	.ic_success {
		width: 52%;
		margin: 0 auto;
		display: block;
		margin-top: 30px;
		margin-bottom: 20px;
	}
}

.code_top {
	background: linear-gradient(90deg, #ff9d00 0%, #ff7916 100%);

	.ic_success {
		width: 100%;
		margin: 0 auto;
		display: block;
		margin-bottom: 20px;
	}
}


.loading {
	margin: 40vh auto;
	text-align: center;

	.loading-text {
		color: #39CCCD;
		font-weight: bold;
	}
}
</style>